import { useUserClientContext } from '@/app/clientContext';

type InternalPageAccess = 'loading' | 'allowed' | 'denied';

/**
 * Tri-state so callers can render a loading placeholder instead of
 * redirecting before user details have resolved.
 */
export const useInternalPageAccess = (): InternalPageAccess => {
  const { isInternalUser, isUserLoaded } = useUserClientContext();

  if (!isUserLoaded) return 'loading';
  return isInternalUser ? 'allowed' : 'denied';
};
